export default __webpack_public_path__ + "fonts/eot/iranyekanwebblack.eot";